/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Harvest
 */
export interface Harvest {
  /**
   *
   * @type {string}
   * @memberof Harvest
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof Harvest
   */
  cageId: string;
  /**
   *
   * @type {string}
   * @memberof Harvest
   */
  siteId: string;
  /**
   *
   * @type {string}
   * @memberof Harvest
   */
  harvestPlantId: string | null;
  /**
   *
   * @type {string}
   * @memberof Harvest
   */
  packagingCode: string | null;
  /**
   *
   * @type {string}
   * @memberof Harvest
   */
  harvestPlant: string | null;
  /**
   *
   * @type {string}
   * @memberof Harvest
   */
  date: string;
  /**
   *
   * @type {number}
   * @memberof Harvest
   */
  biomass: number;
  /**
   *
   * @type {number}
   * @memberof Harvest
   */
  count: number;
  /**
   *
   * @type {number}
   * @memberof Harvest
   */
  weight: number;
  /**
   *
   * @type {boolean}
   * @memberof Harvest
   */
  fullHarvest?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Harvest
   */
  isGraded?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Harvest
   */
  isManual?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Harvest
   */
  isLocked?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Harvest
   */
  isEmergency: boolean;
  /**
   *
   * @type {number}
   * @memberof Harvest
   */
  closingCount: number;
  /**
   *
   * @type {number}
   * @memberof Harvest
   */
  closingWeight: number;
  /**
   *
   * @type {string}
   * @memberof Harvest
   */
  species: HarvestSpeciesEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof Harvest
   */
  certificates?: Array<HarvestCertificatesEnum>;
  /**
   *
   * @type {Array<string>}
   * @memberof Harvest
   */
  explanations?: Array<HarvestExplanationsEnum>;
  /**
   *
   * @type {string}
   * @memberof Harvest
   */
  fromFishGroupId?: string | null;
  /**
   *
   * @type {string}
   * @memberof Harvest
   */
  toFishGroupId?: string | null;
}

export const HarvestSpeciesEnum = {
  Salmon: 'salmon',
  Trout: 'trout',
} as const;

export type HarvestSpeciesEnum = (typeof HarvestSpeciesEnum)[keyof typeof HarvestSpeciesEnum];
export const HarvestCertificatesEnum = {
  Asc: 'ASC',
  Debio: 'Debio',
  Fos: 'FOS',
  GlobalGap: 'GlobalGAP',
  Naturland: 'Naturland',
  Organic: 'Organic',
  PracticeGaabap: 'Practice_GAABAP',
  SoilAssociation: 'SoilAssociation',
  Gladlaks: 'Gladlaks',
  Stp: 'STP',
} as const;

export type HarvestCertificatesEnum = (typeof HarvestCertificatesEnum)[keyof typeof HarvestCertificatesEnum];
export const HarvestExplanationsEnum = {
  CageMab: 'cage_mab',
  SiteMab: 'site_mab',
  Fallowing: 'fallowing',
  HarvestPlantCapacity: 'harvest_plant_capacity',
  ConcessionMab: 'concession_mab',
  SiteConcessionLimit: 'site_concession_limit',
  FishValue: 'fish_value',
  HarvestDemand: 'harvest_demand',
  Manual: 'manual',
  Undefined: 'undefined',
  Synchronized: 'synchronized',
} as const;

export type HarvestExplanationsEnum = (typeof HarvestExplanationsEnum)[keyof typeof HarvestExplanationsEnum];
